import { StepDefinition } from "../types/types";

export const STEPS: StepDefinition[] = [
	{ id: 1, label: "Application Type" },
	{ id: 2, label: "GPM" },
	{ id: 3, label: "TDH" },
	{ id: 4, label: "Pump Curve" },
];
